import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreator from "../../../modules/actions";
import { Container } from "react-bootstrap";
import { ROUTES_PATH } from "../../../constant";
import Back from "../../../common/components/back";
import UserManagementNavbar from "../../UserManagement/userManagementNavbar";
import "./dailyQuotes.css";
import Footer from "../../Footer";
import ContentTable from "../ContentTable/contentTable";
import AddDailyQuotes from "./addDailyQuotes";
import moment from "moment";
import { rename } from "../../../utils/rename";
import DeleteModal from "../deleteModal";
import FilterDropdown from "../../commonComponent/FilterDropdown";

const data = (value) => {
  return {
    search: value,
    date: moment(new Date()).format("YYYY-MM-DD"),
  };
};

const DailyQuotes = (props) => {
  const [scheduledPageNumber, setScheduledPage] = useState(1);
  const [publishedPageNumber, setPublishedPage] = useState(1);
  const [show, setShow] = useState(false);
  const [scheduledDataList, setScheduledList] = useState();
  const [publishedDataList, setPublishedList] = useState();
  const [editQuote, setEditQuote] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(0);
  const [sort, setSort] = useState();
  const [scheduledSort, setScheduledSort] = useState();

  useEffect(() => {
    props.reset();
    props.toggleMainLoader(true);
    props.getQuotes(data("SCHEDULED"), scheduledPageNumber, scheduledSort);
    props.getPublishedQuotes(data("PUBLISHED"), publishedPageNumber, sort);
    props.toggleMainLoader(true);
    setScheduledPage(scheduledPageNumber);
    setPublishedPage(publishedPageNumber);
    if (props.responseSuccess) {
      setDeleteIndex(0)
      setDeleteModal(false)
      setShow(false);
    }
  }, [props.match.params.path, props.responseSuccess, sort,scheduledSort]);

  useEffect(() => {
    setScheduledList(
      rename(
        props.quotes.results,
        "cellOne",
        "cellTwo",
        "quote",
        "scheduled_date"
      )
    );
  }, [props.quotes.results]);

  useEffect(() => {
    setPublishedList(
      rename(
        props.publishedQuotes.results,
        "cellOne",
        "cellTwo",
        "quote",
        "updated_at"
      )
    );
  }, [props.publishedQuotes.results]);

  useEffect(() => {
    if(props.openModal){
      setShow(true);
      setEditQuote(true);
      props.openSearchModal(false)
    }
  }, [])

  const handleBack = () => {
    props.history.push(ROUTES_PATH.CONTENT_MANAGEMENT);
  };

  const changePageScheduled = (selected) => {
    setScheduledPage(selected);
    props.toggleMainLoader(true);
    props.getQuotes(data("SCHEDULED"), selected, scheduledSort);
  };
  const changePagePublished = (selected) => {
    setPublishedPage(selected);
    props.toggleMainLoader(true);
    props.getPublishedQuotes(data("PUBLISHED"), selected, sort);
  };

  const handleAddButton = () => {
    props.toggleMainLoader(false);
    setShow(true);
    setEditQuote(false);
  };

  const handleCancelClose = () => {
    setShow(false);
  };
  const headerFirst = {
    headerOne: "Quote",
    headerTwo: "Scheduled Date",
  };
  const headerSecond = {
    headerOne: "Quote",
    headerTwo: "Updated Date",
  };

  //Functions for Edit and delete
  const handleDelete = (index) => {
    setDeleteIndex(index)
    setDeleteModal(true)
  }
  const handleDeleteClose = () => {
    setDeleteIndex(0)
    setDeleteModal(false)
  }
  const handleDeleteQuotes = () => {
    props.deleteQuotes(deleteIndex)
  }

  const handleEdit = (data) => {
    setEditQuote(true)
    props.contentDetails(data)
    setShow(true);

  }

  const handleEditClose = () => {
    setShow(false)
    setEditQuote(false)
  }

  return (
    <>
      <Container
        style={{
          minHeight: "100vh",
          position: "relative",
          maxWidth: "1046px",
        }}
      >
        <Back
          Back={handleBack}
          backIconClassName={"parent-back-icon"}
          backNavItemClassName={"parent-back-nav"}
          className="parent-back"
        />

        <UserManagementNavbar
          title={"Daily Quotes"}
          isEditButton={false}
          isDeleteButton={false}
          id={"parent-nav-title"}
          className={"parent-navbar"}
          isAddButton={true}
          buttonTitle={"Add Daily Quote"}
          handleAddButton={handleAddButton}
        />
        <ContentTable
            mainHeader={"Published"}
            secondHeader = {<FilterDropdown  sort = {setSort} value = {sort}/>}
            header={headerSecond}
            dataList={publishedDataList}
            rowPerPage={10}
            itemCountFromServer={props.publishedQuotes.count}
            changePage={changePagePublished}
            pageNumber={publishedPageNumber}
            minHeightClass={"min-height-class"}
            contentHeaderOne={"content-header1"}
            contentHeaderTwo={"content-header2"}
            contentHeaderThree={"content-header3"}
            contentCellOne={"content-cell1"}
            contentCellTwo={"content-cell2"}
            contentCellThree={"content-cell3"}
            viewCell={true}
            onDelete={handleDelete}
            onEdit={handleEdit}
            isCellTwoDate = {true}
          />

        <div style={{ marginTop: "27px" }}>
        <ContentTable
          mainHeader={"Scheduled"}
          secondHeader = {<FilterDropdown  sort = {setScheduledSort} value = {scheduledSort}/>}
          header={headerFirst}
          dataList={scheduledDataList}
          rowPerPage={10}
          itemCountFromServer={props.quotes.count}
          changePage={changePageScheduled}
          pageNumber={scheduledPageNumber}
          minHeightClass={"min-height-class"}
          contentHeaderOne={"content-header1"}
          contentHeaderTwo={"content-header2"}
          contentHeaderThree={"content-header3"}
          contentCellOne={"content-cell1"}
          contentCellTwo={"content-cell2"}
          contentCellThree={"content-cell3"}
          viewCell={true}
          onDelete={handleDelete}
          onEdit={handleEdit}
        />
        </div>
        <Footer className={"content-management-footer"} />
        <AddDailyQuotes
          show={show}
          contentClassName={"modal-content-quotes"}
          handleCancelClose={editQuote ? handleEditClose : handleCancelClose}
          title={editQuote ? "Update Daily Quote" : "Add Daily Quote"}
          editQuote={editQuote}

        />

        <DeleteModal modal={deleteModal}
          handleClose={handleDeleteClose}
          handleDelete={handleDeleteQuotes}
          loader={props.loader}
        />
      </Container>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    details: state.userManagementDetails.details,
    quotes: state.quotes,
    publishedQuotes: state.publishedQuotes,
    responseSuccess: state.responseSuccess.responseSuccess,
    loader: state.loader.mainLoader,
    openModal : state.modalFromSearch.openModal,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getQuotes: actionCreator.getQuotes,
      getPublishedQuotes: actionCreator.getPublishedQuotes,
      reset: actionCreator.reset,
      toggleMainLoader: actionCreator.toggleMainLoader,
      deleteQuotes: actionCreator.deleteDailyQuotes,
      contentDetails: actionCreator.getContentDetails,
      openSearchModal : actionCreator.isOpenModalFromSearch,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DailyQuotes);
